// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  useMock: true,
  BM_RETURN_URL: '/wh/bm/return',

  FAKE_REQUEST_DELAY: 0,

  VETINEO_API_WS_URL: 'https://app.vetineo.com/api',
  VETINEO_SSE_URL: 'https://app.vetineo.com/es/mobile-app',

  THUMBNAIL_MAX_WIDTH:  500,
  THUMBNAIL_MAX_HEIGHT:  500,

  // 4k
  IMAGE_MAX_WIDTH:  3840,
  IMAGE_MAX_HEIGHT:  2160,

//  CDN_IMAGES_PATH: 'http://localhost:9100/assets',
  CDN_IMAGES_PATH: 'https://app.vetineo.com/assets',
  // CLOUD_CDN_IMAGES_PATH: 'https://vetineo.pl-waw1.upcloudobjects.com/cdn',
  CLOUD_CDN_IMAGES_PATH: 'https://public.cdn.os1.vetineo.com',
  LOCAL_PUBLIC_ASSETS_PATH: '../../../assets',

  // REGEXP
  PRICE_REGEXP_PATTERN: '^[0-9]{0,3}([0-9]{0,2}|[0-9]{0,2}[\\.]{1}[0-9]{1,2})$',
  TIME_REGEXP_PATTERN: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$',

  THUMBNAILS_URL: 'https://vetineo.pl-waw1.upcloudobjects.com/cdn/',
  PICTURES_URL: 'https://vetineo.pl-waw1.upcloudobjects.com',
  DEFAULT_RESULTS_LIMIT: 50,
  VETINEO_ADMIN_CLINIC_UUID: '86f03e52-c198-11ec-9d64-0242ac120002',

  CHANGES_OPTION: false,

  CLINIC_STATS_START_DATE: '2023-01-01',
};
